import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { getAvailablePractitioners } from "../api/Practitioners";
import { CircularProgress } from "@mui/material";
import { Button } from "../common/Button";
import SelectField from "../common/textfield/SelectField";
import { Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import { decryptData } from "../EncryptDecrypt";
import { checkShedule } from "../apps/api/AppointmentRequests";
import { failed } from "../common/Toastify";
import moment from "moment/moment";



const ProviderPreferenceModal = ({ providerModalShow, handleProviderModalClose, formikQuestionnaire, openBookAppointmentModal }) => {
    const [btnLoading, setBtnLoading] = useState(false);
    const [providerPreference, setProviderPreference] = useState("practitioner");
    const [practitionerList, setPractitionerList] = useState([]);
    const [practitionerId, setPractitionerId] = useState('');
    const [actorIdForNoPref, setActorIdForNoPref] = useState('');
    const patientLocation = (formikQuestionnaire?.location || '');
    const orgId = useSelector((state) => state?.auth?.user?.orgId);

    let isReadOnly = false;

    const formik = useFormik({
        initialValues: {
            practitioner: ""
        },
        validationSchema: () => {
            if (providerPreference === "practitioner") {
                return Yup.object({
                    practitioner: Yup.string().required("Provider is required")
                });
            } else {
                return Yup.object({});
            }
        },
        onSubmit: () => {
            openBookAppointmentModal(providerPreference, formikQuestionnaire, practitionerId, actorIdForNoPref);
        }
    });

    useEffect(() => {
        getAvailablePractitioners(orgId, patientLocation)
            .then(async (res) => {
                // check the active schedules for the next month.
                let now = new Date();
                // res.result only active practitioners i.e active is true
                res.result = res.result.filter(practitioner => practitioner.active);

                let params = {
                    date: now.toISOString().split(".")[0]+"Z",
                    endDate: new Date(new Date(now).setUTCMonth(now.getUTCMonth() + 1)).toISOString().split(".")[0]+"Z",
                    actorId: res.result[0].id,
                    orgId: orgId
                }
                setActorIdForNoPref(res.result[0].id);
                const schedules = await checkShedule(params);
                let activePractitioners = []; // build this array of active practitioners
                if (schedules && schedules.data.length <= 0) {
                    failed('No active practitioners available');
                }
                else if(schedules.data) {
                    // not all schedules retrieved will fit in the date range, and not all
                    // practitioners have any categories assigned to them either.
                    let activeSchedules = schedules.data.filter(sch => {
                        return sch.orgId === orgId
                        && sch.serviceCategory?.length > 0 
                        //&& sch.serviceCategory.filter(cat => new Date(cat.date).getTime() >= now.getTime()).length > 0 
                        && sch.serviceCategory.filter(cat => moment(cat.date).isSameOrAfter(moment(now), "day")).length > 0                      
                    })
                    // now that valid schedules are retrieved, find the matching owners of the schedules are added to the
                    // activePractitioners array, sourced from the full list of practitioners, and then 
                    // dispatch it.
                    activeSchedules.forEach(schedule => {
                        let active = res.result.find(person => person.id === schedule.actorId && !activePractitioners.some(exists => exists.id === schedule.actorId))
                        if(active) 
                            activePractitioners.push(active);
                    })
                    setPractitionerList(activePractitioners.map(ele => (
                            { 
                                value: ele?.id, 
                                name: ele?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), // capitalize all names, surname, given name, etc.
                                id: ele?.id 
                            }
                    )));
                }
                
            })
            .catch((res) => {
                console.log("error fetching practitioner list", res)
            })
    }, []);

    const handlePractitionerChange = (event) => {
        setPractitionerId(event?.target?.value);
        formik.setFieldValue("practitioner", event?.target?.value);
    };


    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            show={providerModalShow}
            onHide={handleProviderModalClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="custom-dialog"
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">Select Provider Preference</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col>
                            {["practitioner", "no preference"].map((val) => (
                                <Form.Check
                                    key={val}
                                    style={{ textTransform: "capitalize", fontSize: "18px", marginRight: "45px" }}
                                    inline
                                    checked={providerPreference === val}
                                    type={"radio"}
                                    label={val === "practitioner" ? "Care Provider" : val}
                                    id={val}
                                    name="practitioner preference"
                                    onChange={(e) => {
                                        setProviderPreference(e.target.id);
                                        if (e.target.id === "no preference") {
                                            setPractitionerId('');
                                        } else {
                                            setPractitionerId(formik.values.practitioner)
                                        }
                                    }}
                                />
                            ))}
                        </Col>
                    </Row>
                    <br />
                    {providerPreference === "practitioner" && (
                        <Row>
                            <SelectField keyField={"practitioner"} label={"Select Provider"} formik={formik} options={practitionerList} readOnly={isReadOnly} onChange={handlePractitionerChange} />
                        </Row>
                    )}

                    <div className="action-wrap">
                        <Button type="submit" disabled={btnLoading}>
                            {btnLoading ? <CircularProgress size={24} /> : 'Next'}
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ProviderPreferenceModal;